export const augsburg = { lng: 10.89304, lat: 48.36599 }

const markerGroup = new H.map.Group()

export default function renderMap(element: HTMLDivElement, options: H.service.Platform.Options) {
  const platform = new H.service.Platform(options)
  const maptypes = platform.createDefaultLayers()

  const pixelRatio = window.devicePixelRatio || 1
  const defaultLayers = platform.createDefaultLayers({
    tileSize: pixelRatio === 1 ? 256 : 512,
    ppi: pixelRatio === 1 ? undefined : 320,
  })

  window.addEventListener('resize', () => {
    map.getViewPort().resize()
  })

  // Instantiate (and display) a map object:
  const map = new H.Map(element, maptypes.normal.map, {
    zoom: 15,
    center: augsburg,
    pixelRatio,
  })

  map.addObject(markerGroup)

  const behavior = new H.mapevents.Behavior(new H.mapevents.MapEvents(map))
  behavior.disable(H.mapevents.Behavior.WHEELZOOM | H.mapevents.Behavior.DBLTAPZOOM)

  const ui = H.ui.UI.createDefault(map, defaultLayers)
  ui.removeControl('zoom')

  return map
}

export function renderHegaxonMap(
  element: HTMLDivElement,
  onSelectHexagon: Function,
  options: H.service.Platform.Options
) {
  const map = renderMap(element, options)
  const hexGridObjects = new H.map.Group()
  map.addObject(hexGridObjects)

  hexGridObjects.addEventListener('tap', evt => {
    onSelectHexagon(evt.target)
  })

  map.addEventListener('mapviewchangeend', () => {
    const bounds = map.getViewBounds()
    const hexGrid = calculateHexGrid(bounds)

    hexGridObjects.removeAll()
    hexGridObjects.addObjects(hexGrid)
    updateHexaGrid(map, markerGroup.getObjects() as H.map.Marker[])
  })

  return map
}

function calculateHexGrid(bounds: H.geo.Rect) {
  const hexgrid = []

  // Determine where the upper left-hand corner is.
  const ne = new H.geo.Point(bounds.getTop(), bounds.getRight())
  const sw = new H.geo.Point(bounds.getBottom(), bounds.getLeft())

  // Determine the actual distance between tiles
  const diagonal = ne.distance(sw)
  const gridSize = diagonal / 20
  const d = 2 * gridSize * Math.cos(Math.PI / 6)

  let point = new H.geo.Point(ne.lat, sw.lng)

  // ... Until we're at the bottom of the screen...
  while (point.lat > sw.lat) {
    // Keep this so that we know where to return to when we're done moving across to the right
    const leftPoint = new H.geo.Point(point.lat, point.lng)
      .walk(150, d)
      .walk(210, d)
      .walk(270, d)
      .walk(90, d)

    let step = 1

    while (point.lng < ne.lng) {
      // Use the modulus of step to determing if we want to angle up or down
      if (step % 2 === 0) {
        point = new H.geo.Point(point.lat, point.lng).walk(30, d)
      } else {
        point = new H.geo.Point(point.lat, point.lng).walk(150, d)
      }

      step++ // Increment the step

      // Draw the hexagon!
      // First, come up with the corners.
      const strip = new H.geo.Strip()
      for (let v = 1; v < 7; v++) {
        const angle = v * 60
        const vertex = point.walk(angle, d / Math.sqrt(3))
        strip.pushLatLngAlt(vertex.lat, vertex.lng, 100)
      }

      // Create the shape
      const hexagon = new H.map.Polygon(strip, {
        data: {
          points: strip.getLatLngAltArray(),
        },
        style: {
          lineWidth: 2,
          strokeColor: 'rgba(0, 85, 170, 0.3)',
          fillColor: 'transparent',
        },
      })

      // Push it to hexgrid so we can delete it later
      hexgrid.push(hexagon)
    }

    // Return to the left.
    point = leftPoint
  }

  return hexgrid
}

export function addMarkers(map: H.Map, markers: H.map.Marker[]) {
  markerGroup.removeAll()
  markerGroup.addObjects(markers)

  updateHexaGrid(map, markers)

  return map
}

export function updateHexaGrid(map: H.Map, markers: H.map.Marker[]) {
  map.getObjects().forEach(object => {
    if (object instanceof H.map.Polygon) {
      const bounds = object.getBounds()
      const numberOfMatchingPoints = markers
        .map(marker => bounds.containsPoint(marker.getPosition()) === true)
        .filter(bools => bools === true).length

      if (numberOfMatchingPoints > 0) {
        object.setStyle({
          ...object.getStyle(),
          fillColor: `rgba(70, 225, 200, ${Math.min(numberOfMatchingPoints / 10, 1)})`,
        })
      }
    }
  })
}

export function centerCurrentLocation(map: H.Map) {
  navigator.geolocation.getCurrentPosition(
    position => {
      const point = new H.geo.Point(position.coords.latitude, position.coords.longitude)
      console.log('location', point)
      map.setCenter(point)
    },
    () => {
      console.log('no location')
    }
  )
}

export function addSimulatedMarker(map: H.Map, interval = 2000) {
  const intervalId = setInterval(() => {
    const center = map.getCenter()
    const randomPoint = {
      lat: center.lat + Math.random() * 0.5 * (Math.random() > 0.5 ? -1 : 1),
      lng: center.lng + Math.random() * 0.5 * (Math.random() > 0.5 ? -1 : 1),
    }
    map.addObject(new H.map.Marker(randomPoint))
  }, interval)

  return intervalId
}



// WEBPACK FOOTER //
// ./src/components/map.ts